module.exports = __webpack_public_path__ + "pc/img/logob.0185161.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logob.png
// module id = oZRt
// module chunks = 11 12 13 14